import * as types from "../types/types";

export const updateManageDependencyAction = (data) => ({
  payload: data,
  type: types.UPDATE_MANAGE_DEPENDENCY,
});
